const header = document.getElementById("Header");
const mobileNavigation = document.querySelector(".navigation-menu-mobile");
const searchButton = document.querySelector(".search-button");
const searchBoxDesktop = document.querySelector(".search-box-desktop");
const searchInput = <HTMLInputElement>document.querySelector(".search-input-desktop");

if (header && mobileNavigation) {
    const burgerMenu = header.querySelector("#BurgerMenu");

    if (burgerMenu) {
        burgerMenu.addEventListener("click", () => {
            const active = burgerMenu.classList.toggle("open");
            mobileNavigation.classList.toggle("open", active);
            burgerMenu.setAttribute("aria-expanded", active.toString());
        });
    }

    mobileNavigation.addEventListener("click", (e) => {
        const target = e.target as HTMLElement;

        // Toggle forward
        const toggleBtn = target.closest(".nav-child-toggle");
        if (toggleBtn) {
            const li = toggleBtn.closest(".nav-item");
            if (li) li.classList.add("is-open");
            return;
        }

        // Toggle back
        const backBtn = target.closest(".nav-back-button");
        if (backBtn) {
            const openLi = backBtn.closest(".nav-item.is-open");
            if (openLi) openLi.classList.remove("is-open");
            return;
        }
    });

    window.addEventListener("scroll", () => {
        if (window.scrollY > 0 && !header.classList.contains("collapsed")) {
            header.classList.add("collapsed");
        } else if (window.scrollY == 0 && header.classList.contains("collapsed")) {
            header.classList.remove("collapsed");
        }
    });
}
if (searchButton && searchBoxDesktop && searchInput) {
    searchButton.addEventListener("click", () => {
        searchBoxDesktop.classList.toggle("open");
        searchInput.focus();
    });
}
